window._ = require('lodash');

import { getBaseURL } from '@vue/store/helpers.js';
window.baseURL = getBaseURL();

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');

    require('sweetalert').default;
    window.inView = require('in-view');
    window.Dropzone = require('dropzone').default;
    require('select-woo').default;
    require('hoverintent').default;
} catch (e) {
    console.warn(e);
}

window.initOATooltips = (mobile = false) => {
    let sw = window.outerWidth;
    if(!mobile && sw < 992) return false;
    let settings = {};
    if(!mobile) settings.trigger = 'hover'
    jQuery(document).ready(function($){
        $('[data-toggle="tooltip"]').tooltip(settings);
        $('.oa-tool-tip').tooltip(settings);
    });
}

window.clearOATooltips = () => {
  $('[data-toggle="tooltip"]').tooltip('hide');
  $('.oa-tool-tip').tooltip('hide');
}

window.initOATooltips();

import './analytics/jquery.oa-ga.js'; // Custom Analytics reporting
import './partials/nav-toggle.js';
import './partials/jquery.location-form.js';
import './partials/jquery.office-select-widget.js';
import './partials/flipping-cards.js';
// import './partials/rw-accessibility';
import './vendor/slick/slick.js';
import './partials/dashboard-nav.js';



/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });


/* x=- x=- x=-x= x- =x-= x-= x- x= -x=- =-x= -x=- -
    Collapsing Toggles
x=- x=- =x- x=- x=- x=-x =x-=x- =x- =x- =x-=x- =x-*/
$(document).on('click', '.collapse-toggle', function(evt) {
    evt.preventDefault();
    var parent = $(this).closest('.oa-panel');
    parent.find('.panel-body').slideToggle();
});

/* x=- x=- x=-x= x- =x-= x-= x- x= -x=- =-x= -x=- -
    Need to see what element is focused as you tab through the page? Useful when we were improving our focus state
x=- x=- =x- x=- x=- x=-x =x-=x- =x- =x- =x-=x- =x-*/
// document.onkeydown = function(){
//     console.log(document.activeElement);
// }